import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterListModule } from 'src/app/filterlist/filterlist.module';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterDropdownComponent } from 'src/app/shared/components/filter-dropdown/filter-dropdown.component';
import { DateRangeFilterComponent } from 'src/app/shared/components/date-range-filter/date-range-filter.component';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { SavedFiltersComponent } from 'src/app/shared/saved-filters/saved-filters.component';
import { FilterDrawerComponent, FilterDrawerSectionComponent, FilterDrawerToggleComponent } from 'src/app/shared/filter-drawer/filter-drawer.component';
@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FilterListModule,
    DynamicTableModule,
    TranslateModule,
    FilterDropdownComponent,
    DateRangeFilterComponent,
    ApplicationPipesModule,
    SavedFiltersComponent,
    FilterDrawerComponent,
    FilterDrawerSectionComponent,
    FilterDrawerToggleComponent
  ],
  declarations: [AlertComponent],
  exports: [AlertComponent]

})
export class AlertModule { }
